/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tile_Levels_BodyInputs */



/**
* | output |
* | --- |
* | "XP for the minutes members spend talking and in voice, so spam doesn't climb the board." |
*
* @param {Landing_Tile_Levels_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_tile_levels_body = /** @type {((inputs?: Landing_Tile_Levels_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tile_Levels_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("XP начисляется за минуты общения в чате и в голосовых каналах, поэтому спамом в таблице лидеров не подняться.")
	return /** @type {LocalizedString} */ ("XP for the minutes members spend talking and in voice, so spam doesn't climb the board.")
});